export const logLevels = ['error', 'warn', 'info', 'debug'];
export function isLogLevel(value) {
    return typeof value === 'string' && logLevels.includes(value);
}
//# sourceMappingURL=logSink.js.map